<div data-spy="scroll" data-target=".fixed-top">
  

<app-public-navbar></app-public-navbar>

      <!-- Navigation -->
    <!-- <nav class="navbar navbar-expand-lg fixed-top navbar-light">
        <div class="container"> -->

            <!-- Text Logo - Use this if you don't have a graphic logo -->
            <!-- <a class="navbar-brand logo-text page-scroll" href="index.html">Kora</a> -->

            <!-- Image Logo --> 
            <!-- <a class="navbar-brand logo-image" href="">
                <img src="assets/images/xchange.png" alt="alternative"></a>

           <button class="navbar-toggler p-0 border-0" type="button" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="true" aria-label="toggle navigation" data-toggle="collapse">
                <span class="navbar-toggler-icon"></span>
            </button> 

            <div class="collapse1" id="navbarsExampleDefault">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link page-scroll"   (click)="gotoScroll('header')">Home <span class="sr-only">(current)</span></a>
                    </li>
                    
                    <li class="nav-item">
                        <a routerLink="/intro" class="nav-link page-scroll"   (click)="gotoScroll('intro')">Intro</a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/features" class="nav-link page-scroll"   (click)="gotoScroll('features')">Features</a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/howItWorks" class="nav-link page-scroll"   (click)="gotoScroll('details')">Details</a>
                    </li> 
                    <li class="nav-item" *ngIf="!user" >
                        <a routerLink="/sale-support" class="nav-link page-scroll"  href="javascript:void(0)"  >Sales Support </a>
                    </li>
                    <li class="nav-item" *ngIf="!user" >
                        <a routerLink="/faqs" class="nav-link page-scroll"  href="javascript:void(0)"   >FAQ's</a>
                    </li> -->
                  <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">Drop</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown01">
                            <a class="dropdown-item page-scroll" href="article.html">Article Details</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="terms.html">Terms Conditions</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="privacy.html">Privacy Policy</a>
                        </div>
                    </li>  -->
                     <!-- <li class="nav-item" *ngIf="this.extra" >
                            <a routerLink="/account/register-email" class="btn-solid-sm page-scroll" href="">Signup</a>
                            <a  routerLink="/account/login"  class="btn-solid-sm page-scroll" href="">Login</a>
                     </li>
                     <li class="nav-item" *ngIf="!this.extra"  >
                        <a  routerLink=""   class="btn-solid-sm page-scroll" (click)="dashboard()">Go to Content List</a>
                        <a routerLink="/account/login"   class="btn-solid-sm page-scroll" (click)="logout()">Logout</a>
                     </li>
                </ul> -->
               
                 <!-- <span class="nav-item" *ngIf="user">
                    <a routerLink="/{{ (user.type == 1) ? 'buyer' : 'seller'}}" class="btn-solid-sm page-scroll" href="">Dashboard</a>
                </span> -->
            <!-- </div> end of navbar-collapse -->
        <!-- </div> end of container -->
    <!-- </nav>  -->





    <!-- <nav class="navbar navbar-expand-lg fixed-top navbar-light">
        <div class="container"> -->

            <!-- Text Logo - Use this if you don't have a graphic logo -->
            <!-- <a class="navbar-brand logo-text page-scroll" href="index.html">Kora</a> -->

            <!-- Image Logo --> 
            <!-- <a class="navbar-brand logo-image" href="">
                <img src="assets/images/xchange.png" alt="alternative"></a>

           <button class="navbar-toggler p-0 border-0" type="button" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="true" aria-label="toggle navigation" data-toggle="collapse">
                <span class="navbar-toggler-icon"></span>
            </button> 

            <div class="collapse1" id="navbarsExampleDefault">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link page-scroll" routerLink="/" >Home <span class="sr-only">(current)</span></a>
                    </li>
                    
                    <li class="nav-item">
                        <a routerLink="/intro" class="nav-link page-scroll"   (click)="gotoScroll('intro')">Intro</a>
                    </li>
                     <li class="nav-item">
                        <a routerLink="/howItWorks" class="nav-link page-scroll"   (click)="gotoScroll('details')">How it Works</a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/features" class="nav-link page-scroll"   (click)="gotoScroll('features')">Features</a>
                    </li>
                    
                    <li class="nav-item" *ngIf="!user" >
                        <a routerLink="/contact-us" class="nav-link page-scroll"  href="javascript:void(0)"  >Contact Us </a>
                    </li>
                    <li class="nav-item" *ngIf="!user" >
                        <a routerLink="/faqs" class="nav-link page-scroll"  href="javascript:void(0)"   >FAQ's</a>
                    </li> -->
                  <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">Drop</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown01">
                            <a class="dropdown-item page-scroll" href="article.html">Article Details</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="terms.html">Terms Conditions</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="privacy.html">Privacy Policy</a>
                        </div>
                    </li>  -->
                     <!-- <li class="nav-item" *ngIf="this.extra" >
                            <a routerLink="/account/register-email" class="btn-solid-sm page-scroll" href="">Signup</a>
                            <a  routerLink="/account/login"  class="btn-solid-sm page-scroll" href="">Login</a>
                     </li>
                     <li class="nav-item" *ngIf="!this.extra"  >
                        <a  routerLink=""   class="btn-solid-sm page-scroll" (click)="dashboard()">Go to Content List</a>
                        <a routerLink="/account/login"   class="btn-solid-sm page-scroll" (click)="logout()">Logout</a>
                     </li>
                </ul> -->
               
                 <!-- <span class="nav-item" *ngIf="user">
                    <a routerLink="/{{ (user.type == 1) ? 'buyer' : 'seller'}}" class="btn-solid-sm page-scroll" href="">Dashboard</a>
                </span> -->
            <!-- </div> end of navbar-collapse -->
        <!-- </div> end of container -->
    <!-- </nav>  -->
    <!-- end of navigation -->


   

  
      <!-- <div class="container">

        <div class="row py-5 mt-5">
          <div class="col-lg-9 mx-auto text-white text-center">
            <h1 class="display-4">Frequently Asked Questions</h1>
          </div>
        </div>
      
        <div class="row">
          <div class="col-lg-9 mx-auto">
            <div id="accordionExample" class="accordion shadow">
      
              <div class="cards">
                <div id="headingOne" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                      aria-controls="collapseOne"
                      class="btn btn-link text-dark font-weight-bold text-uppercase collapsible-link">What is Connekkt Xchange?</button>
                  </h2>
                </div>
                <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordionExample" class="collapse show">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">Connekkt Xchange is a digital media agency specializing in content creation,
                       social media management, and digital marketing strategies. We help brands connect with their audience effectively.</p>
                  </div>
                </div>
              </div>
      
              <div class="cards">
                <div id="headingTwo" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                      aria-controls="collapseTwo"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">What services do you offer?</button>
                  </h2>
                </div>
                <div id="collapseTwo" aria-labelledby="headingTwo" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">We Offer a Range of Services, Including: <br>

                      •        Content Creation: Blogs, videos, graphics <br>
                      •        Connekkt Xchange: Content marketplace <br>
                      •        Brand Development <br>
                      •        Analytics and Reporting</p>
                  </div>
                </div>
              </div>
              <div class="cards">
                <div id="headingThree" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                      aria-controls="collapseThree"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">How can I get started with Connekkt Xchange?</button>
                  </h2>
                </div>
                <div id="collapseThree" aria-labelledby="headingThree" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">Getting Started is Easy! <br>
                      Simply register an account as a Seller or a Buyer based on your requirements and get started. If you have any queries, reach out to us at support@connekktxchange.com.</p>
                  </div>
                </div>
              </div>
                <div class="cards">
                  <div id="headingfour" class="card-header bg-white shadow-sm border-0">
                    <h2 class="mb-0">
                      <button type="button" data-toggle="collapse" data-target="#collapsefour" aria-expanded="false"
                        aria-controls="collapsefour"
                        class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link"> What industries do you work with?</button>
                    </h2>
                  </div>
                  <div id="collapsefour" aria-labelledby="headingfour" data-parent="#accordionExample" class="collapse">
                    <div class="cards_2 p-3">
                      <p class="font-weight-light m-0">We currently work exclusively with the Entertainment Industry.</p>
                    </div>
                  </div>
                </div>
              <div class="cards">
                <div id="headingfive" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapsefive" aria-expanded="false"
                      aria-controls="collapsefive"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link"> Is there a video to understand about Connekkt Xchange?</button>
                  </h2>
                </div>
                <div id="collapsefive" aria-labelledby="headingfive" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">Yes, please check our explainer video for more information.</p>
                  </div>
                </div>
              </div>
              <div class="cards">
                <div id="headingsix" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapsesix" aria-expanded="false"
                      aria-controls="collapsesix"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link"> What is your pricing structure?</button>
                  </h2>
                </div>
                <div id="collapsesix" aria-labelledby="headingsix" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">For pricing-related queries, please reach out to infoConnekkt Xchange.</p>
                  </div>
                </div>
              </div>



               <div class="cards">
                <div id="headingseven" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapseseven" aria-expanded="false"
                      aria-controls="collapseseven"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">  How do I contact support?</button>
                  </h2>
                </div>
                <div id="collapseseven" aria-labelledby="headingseven" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">You can reach our support team via the contact form on our website or email us directly at support@connekktxchange.com. We’re here to help!</p>
                  </div>
                </div>
              </div>
                 <div class="cards">
                  <div id="headingeight" class="card-header bg-white shadow-sm border-0">
                    <h2 class="mb-0">
                      <button type="button" data-toggle="collapse" data-target="#collapseeight" aria-expanded="false"
                        aria-controls="collapseeight"
                        class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">  Who is a seller in Connekkt Xchange</button>
                    </h2>
                  </div>
                  <div id="collapseeight" aria-labelledby="headingeight" data-parent="#accordionExample" class="collapse">
                    <div class="cards_2 p-3">
                      <p class="font-weight-light m-0">A seller in Connekkt Xchange typically refers to a content creator, brand, or individual offering content on the Connekkt Xchange Platform.</p>
                    </div>
                  </div>
                </div>
                 <div class="cards">
                  <div id="headingnine" class="card-header bg-white shadow-sm border-0">
                    <h2 class="mb-0">
                      <button type="button" data-toggle="collapse" data-target="#collapsenine" aria-expanded="false"
                        aria-controls="collapsenine"
                        class="btn btn-link collapsed text-dark font-wnine-bold text-uppercase collapsible-link">  Who is a buyer in Connekkt Xchange</button>
                    </h2>
                  </div>
                  <div id="collapsenine" aria-labelledby="headingnine" data-parent="#accordionExample" class="collapse">
                    <div class="cards_2 p-3">
                      <p class="font-weight-light m-0">
                        A buyer in Connekkt Xchange is typically an individual or organization seeking to purchase products, services, or content offered by sellers on the platform. Buyers may include:<br>

        •        Brands looking for content solutions <br>
        •        Consumers interested in specific content <br>
        •        Businesses seeking partnerships to enhance their outreach and engagement
                      </p>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </div> -->

      <!-- <br> <br> -->
  
  <div class="faq-section">
  <div class="faq-outer" >
    <div class="grad1" ><img src="assets/newImages/Fill-faq.png" alt=""></div>
                <div class="title-cont" >
    <span class="faq-title">Frequently asked questions</span>
</div>
    <!-- Page Title -->
 
    <div class="faq-layout">

      <!-- LEFT: FAQ LIST -->
      <div class="faq-box">

  <div class="row">
          <div class="col-lg-12 ">
            <div id="accordionExample" class="accordion shadow">
      
              <div class="cards">
                <div id="headingOne" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                      aria-controls="collapseOne"
                      class="btn btn-link text-dark font-weight-bold text-uppercase collapsible-link">What is Connekkt Xchange?</button>
                  </h2>
                </div>
                <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordionExample" class="collapse show">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">Connekkt Xchange is a next‑generation B2B content marketplace that enables publishers, studios, platforms, and distributors to seamlessly discover, license, distribute, and monetize content across global markets.</p>
                  </div>
                </div>
              </div>
      
              <div class="cards">
                <div id="headingTwo" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                      aria-controls="collapseTwo"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">What services do you offer?</button>
                  </h2>
                </div>
                <div id="collapseTwo" aria-labelledby="headingTwo" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">We Offer a Range of Services, Including: <br>

                      •        Content Creation: Blogs, videos, graphics <br>
                      •        Connekkt Xchange: Content marketplace <br>
                      •        Brand Development <br>
                      •        Analytics and Reporting</p>
                  </div>
                </div>
              </div>
              <div class="cards">
                <div id="headingThree" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                      aria-controls="collapseThree"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">How can I get started with Connekkt Xchange?</button>
                  </h2>
                </div>
                <div id="collapseThree" aria-labelledby="headingThree" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">Getting Started is Easy! <br>
                      Simply register an account as a Seller or a Buyer based on your requirements and get started. If you have any queries, reach out to us at support@connekktxchange.com.</p>
                  </div>
                </div>
              </div>
                <div class="cards">
                  <div id="headingfour" class="card-header bg-white shadow-sm border-0">
                    <h2 class="mb-0">
                      <button type="button" data-toggle="collapse" data-target="#collapsefour" aria-expanded="false"
                        aria-controls="collapsefour"
                        class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link"> What industries do you work with?</button>
                    </h2>
                  </div>
                  <div id="collapsefour" aria-labelledby="headingfour" data-parent="#accordionExample" class="collapse">
                    <div class="cards_2 p-3">
                      <p class="font-weight-light m-0">We currently work exclusively with the Entertainment Industry.</p>
                    </div>
                  </div>
                </div>
              <div class="cards">
                <div id="headingfive" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapsefive" aria-expanded="false"
                      aria-controls="collapsefive"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link"> Is there a video to understand about Connekkt Xchange?</button>
                  </h2>
                </div>
                <div id="collapsefive" aria-labelledby="headingfive" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3" (click)="goToVideo()"
style="cursor: pointer;">
                    <p class="font-weight-light m-0">Yes, please check our explainer <a style="color:#0083ff;" > video</a> for more information.</p>
                  </div>
                </div>
              </div>
              <div class="cards">
                <div id="headingsix" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapsesix" aria-expanded="false"
                      aria-controls="collapsesix"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link"> What is your pricing structure?</button>
                  </h2>
                </div>
                <div id="collapsesix" aria-labelledby="headingsix" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">For pricing-related queries, please reach out to <a href="mailto:support@connekktxchange.com">
          <strong>support@connectxchange.media</strong></a></p>
                  </div>
                </div>
              </div>



               <div class="cards">
                <div id="headingseven" class="card-header bg-white shadow-sm border-0">
                  <h2 class="mb-0">
                    <button type="button" data-toggle="collapse" data-target="#collapseseven" aria-expanded="false"
                      aria-controls="collapseseven"
                      class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">  How do I contact support?</button>
                  </h2>
                </div>
                <div id="collapseseven" aria-labelledby="headingseven" data-parent="#accordionExample" class="collapse">
                  <div class="cards_2 p-3">
                    <p class="font-weight-light m-0">You can reach our support team via the contact form on our website or email us directly at support@connekktxchange.com. We’re here to help!</p>
                  </div>
                </div>
              </div>
                 <div class="cards">
                  <div id="headingeight" class="card-header bg-white shadow-sm border-0">
                    <h2 class="mb-0">
                      <button type="button" data-toggle="collapse" data-target="#collapseeight" aria-expanded="false"
                        aria-controls="collapseeight"
                        class="btn btn-link collapsed text-dark font-weight-bold text-uppercase collapsible-link">  Who is a seller in Connekkt Xchange</button>
                    </h2>
                  </div>
                  <div id="collapseeight" aria-labelledby="headingeight" data-parent="#accordionExample" class="collapse">
                    <div class="cards_2 p-3">
                      <p class="font-weight-light m-0">A seller in Connekkt Xchange typically refers to a content creator, brand, or individual offering content on the Connekkt Xchange Platform.</p>
                    </div>
                  </div>
                </div>
                 <div class="cards">
                  <div id="headingnine" class="card-header bg-white shadow-sm border-0">
                    <h2 class="mb-0">
                      <button type="button" data-toggle="collapse" data-target="#collapsenine" aria-expanded="false"
                        aria-controls="collapsenine"
                        class="btn btn-link collapsed text-dark font-wnine-bold text-uppercase collapsible-link">  Who is a buyer in Connekkt Xchange</button>
                    </h2>
                  </div>
                  <div id="collapsenine" aria-labelledby="headingnine" data-parent="#accordionExample" class="collapse">
                    <div class="cards_2 p-3">
                      <p class="font-weight-light m-0">
                        A buyer in Connekkt Xchange is typically an individual or organization seeking to purchase products, services, or content offered by sellers on the platform. Buyers may include:<br>

        •        Brands looking for content solutions <br>
        •        Consumers interested in specific content <br>
        •        Businesses seeking partnerships to enhance their outreach and engagement
                      </p>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </div>         
        </div>
     
        <!-- <div class="faq-item" *ngFor="let f of faqs; let i = index">
          <button class="faq-question" (click)="toggle(i)">
            {{ f.question }}
            <span class="icon">{{ f.open ? '-' : '+' }}</span>
          </button>

          <div class="faq-answer" [class.open]="f.open">
            <p>{{ f.answer }}</p>
          </div>
        </div> -->

     

      <!-- RIGHT: HELP CARD -->
      <div class="help-card">
        <img src="assets/newImages/faqPage.png" class="help-icon">

        <h3>Do you have more questions?</h3>
        <p>You can reach us anytime. Drop us a little more about you and our team will reach out within 24 hours.</p>
        
        <button class="help-btn" >
<a href="mailto:support@connekktxchange.com">           Write a mail to us </a></button>
      </div>
    <div class="grad2" ><img src="assets/newImages/fill-faq2.png" alt=""></div>

    </div>
  </div>
</div>


      <div class="footer">
          <div class="container">
              <div class="row">
                  <div class="col-lg-12">
                      <div class="footer-col first">
                          <h6>About Connekkt Xchange</h6>
                          <p class="p-small">Connekkt Xchange is a next‑generation B2B content marketplace that enables publishers, studios, platforms, and distributors to seamlessly discover, license, distribute, and monetize content across global markets.
                          </p>
                      </div> <!-- end of footer-col -->
                      <div class="footer-col second">
                          <h6>Useful Links</h6>
                          <ul class="list-unstyled li-space-lg p-small">
                              <li><a href="/terms&conditions">Terms & Conditions</a><br/> <a href="/privacy-policy">Privacy
                                      Policy</a><br> <a routerLink="/faqs">FAQs</a><br><a routerLink="/privacySettings">Cookie Preferences</a> <br><a routerLink="/contact-us">Contact Us</a> </li>
                              <!-- <li>Useful: <a href="#">Colorpicker</a>, <a href="#">Icon Library</a>, <a
                                      href="#">Illustrations</a></li>
                              <li>Menu: <a class="page-scroll" href="#header">Home</a>, <a class="page-scroll"
                                      href="#intro">Intro</a>, <a class="page-scroll" href="#features">Features</a>, <a
                                      class="page-scroll" href="#details">Details</a></li> -->
                          </ul>
                      </div> <!-- end of footer-col -->
                      <div class="footer-col third">
                          <span class="fa-stack">
                              <a href="#your-link">
                                  <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-facebook-f fa-stack-1x"></i> -->
                                 <img class="footer-img" src="assets/newImages/twitter.png" alt="">

                              </a>
                          </span>
                          <span class="fa-stack">
                              <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/facebook.png" alt="">

                                  <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-twitter fa-stack-1x"></i> -->
                              </a>
                          </span>
                          <span class="fa-stack">
                              <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/instagram.png" alt="">

                                  <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-pinterest-p fa-stack-1x"></i> -->
                              </a>
                          </span>
                          <span class="fa-stack">
                              <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/pinterest.png" alt="">

                                  <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-instagram fa-stack-1x"></i> -->
                              </a>
                          </span>
                          <p class="p-small">We would love to hear from you <a
                                  href="mailto:support@connekktxchange.com"><strong>support@connekktxchange.com</strong></a>
                                  <br/>
                                  <!-- <a
                                      href="tel:+4407466 31893"><strong>+44 07466 331893</strong></a></p> -->
  
                      </div> <!-- end of footer-col -->
                  </div> <!-- end of col -->
              </div> <!-- end of row -->
  
               <!-- Copyright -->
      <div class="copyright">
          <div class="container">
              <div class="row">
                  <div class="col-lg-12">
                      <p class="p-small">Copyright © <a href="#your-link">Connekkt Xchange</a></p>
                  </div> <!-- end of col -->
              </div> <!-- enf of row -->
          </div> <!-- end of container -->
      </div> <!-- end of copyright -->
      
          </div> <!-- end of container -->
      </div> </div>